import Vue from 'vue'
import { gsap } from 'gsap'

export default new Vue({
  data () {
    return {
      home: null,
      globe: null,
      shouldResetRun: false,
      isMobile: false
    }
  },
  methods: {
    registerComponent (name, component) {
      this[name] = component
      if (this.shouldResetRun && this.home && this.globe) {
        this.reverseAnimate(this.home)
      }
    },
    masterAnimate (params) {
      this.isMobile = params.mobile
      return new Promise((resolve, reject) => {
        var tl = gsap.timeline({ onComplete: () => { resolve() } })
        tl.add(this.animateText(this.home))
        tl.add(this.animateGlobe(this.globe), '<')
      })
    },
    reverseAnimate () {
      var tl = gsap.timeline()
      tl.add(this.reverseGlobe(this.globe))
      tl.add(this.reverseText(this.home))
    },
    animateText (target) {
      var tl = gsap.timeline()
      tl.to(target, { blur: 30, textOpacity: 0 })
      return tl
    },
    reverseText (target) {
      var tl = gsap.timeline()
      tl.set(target, { blur: 30, textOpacity: 0 })
      tl.to(target, { blur: 0, textOpacity: 1 })
    },
    animateGlobe (target) {
      var tl = gsap.timeline()
      tl.to(target,
        {
          fov: 0.5,
          pan: this.isMobile ? -6 : -4,
          Yrotation: 2,
          duration: 0.8,
          ease: 'power2.in',
          onStart: () => {
            target.fovAnimating = true
            target.panAnimating = true
            target.rotationAnimating = true
          },
          onComplete: () => {
            target.fovAnimating = false
            target.panAnimating = false
            target.rotationAnimating = false
          }
        }
      )
      return tl
    },
    reverseGlobe (target) {
      var tl = gsap.timeline()
      tl.set(target,
        {
          fov: 0.5,
          pan: 4,
          Yrotation: 2
        }
      )
      tl.to(target,
        {
          fov: 1,
          pan: 1,
          Yrotation: 1.1,
          duration: 1.2,
          ease: 'power2.out',
          onStart: () => {
            target.fovAnimating = true
            target.panAnimating = true
            target.rotationAnimating = true
          },
          onComplete: () => {
            target.fovAnimating = false
            target.panAnimating = false
            target.rotationAnimating = false
          }
        }
      )
      return tl
    },
    setShouldResetRun (value) {
      this.shouldResetRun = value
    }
  }
})
